import { createComponentBroadcast } from '../../common-scripts/componentBroadcast'
import ursLoginComponent from './ursLoginComponent'
import logger from '../../common-scripts/logger'


$(function () {
  $('.urs-login-component').on('click', function (e) {
    e.stopPropagation()
  })
})

$(function () {
  const { selector, actions } = ursLoginComponent
  const $modal = $(selector)
  const modalBroadcast = createComponentBroadcast(ursLoginComponent)

  modalBroadcast.on(actions.show, () => {
    logger.log('modalBroadcast show....')
    $modal.css({ 'z-index': 9999, opacity: 1 })
  })

  modalBroadcast.on(actions.hide, () =>{
    logger.log('modalBroadcast hide....')
    $modal.css({ 'z-index': -9999, opacity: 0 })
  })
})
